import omit from 'lodash/omit';
import { ColorManager } from 'vet-bones/utils';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';
import { queryBuilderColorsById } from 'src/templates/styles/colors';

export const getColorIdForIri = (model: Model, iri: string) => {
  // assign a new color based on current colors
  const currentColors: Record<
    string,
    { iri: string; color: string; colorId: string }
  > = {};
  Object.entries(model.modelData.colorIdsByIri).forEach(([iri, colorId]) => {
    const color = queryBuilderColorsById[colorId];
    if (color) {
      currentColors[iri] = { iri, color, colorId };
    }
  });

  const colorManager = new ColorManager(currentColors);
  const newColor = colorManager.getColorForIri(iri);
  return newColor.id;
};

export const setColorIdForIri =
  (iri: string, colorId?: string) => (model: Model) => {
    // use provided color id
    if (colorId) {
      setDataProperty<ModelData>(model)(model.modelData, 'colorIdsByIri', {
        ...model.modelData.colorIdsByIri,
        [iri]: colorId,
      });
      return;
    }

    setDataProperty<ModelData>(model)(model.modelData, 'colorIdsByIri', {
      ...model.modelData.colorIdsByIri,
      [iri]: getColorIdForIri(model, iri),
    });
  };

export const removeColorIdForIri = (iri: string) => (model: Model) => {
  if (model.modelData.colorIdsByIri[iri] !== undefined) {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'colorIdsByIri',
      omit(model.modelData.colorIdsByIri, iri)
    );
  }
};
